import gsap from 'gsap'

export default () => {
    const selectors = {
        page: 'body',
        links: 'a[href]',
    }

    function isInternalLink(link) {
        const url = new URL(link.href, window.location.origin)

        return (
            url.origin === window.location.origin &&
            !link.target &&
            !link.hasAttribute('download') &&
            !link.href.includes('#') &&
            link.href !== window.location.href
        )
    }

    function fadeInPage() {
        gsap.fromTo(
            selectors.page,
            { autoAlpha: 0 },
            {
                autoAlpha: 1,
                duration: 0.45,
                ease: 'power2.out',
                clearProps: 'all',
            }
        )
    }

    function fadeOutAndGo(url) {
        gsap.to(selectors.page, {
            autoAlpha: 0,
            duration: 0.35,
            ease: 'power2.inOut',
            onComplete: () => {
                window.location.href = url
            },
        })
    }

    function bindLinks() {
        document.addEventListener('click', (e) => {
            const link = e.target.closest(selectors.links)

            if (!link || !isInternalLink(link)) {
                return
            }

            e.preventDefault()
            fadeOutAndGo(link.href)
        })
    }

    function init() {
        if (!document.querySelector(selectors.page)) {
            return
        }

        fadeInPage()
        bindLinks()

        window.addEventListener('pageshow', () => {
            gsap.set(selectors.page, { autoAlpha: 1 })
            fadeInPage()
        })
    }

    return Object.freeze({
        init,
    })
}